<template>
  <layout-default>
    <div id="profile" class="v-inner--wrap">
      <inner-drawer :routes="getProfileMenu">
        <template v-slot:header>
          <profile-card
            @updateAvatar="updateAvatar"
            :get-mime-types="getMimeTypes"
            :profile="user"
          />
        </template>
      </inner-drawer>
      <inner-content>
        <router-view :key="$route.name" />
      </inner-content>
    </div>
  </layout-default>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InnerDrawer from '@/components/InnerDrawer.vue'
import InnerContent from '@/components/InnerContent.vue'
import ProfileCard from '@/components/profile/ProfileCard.vue'
// import axios from 'axios';
import { protectedRoute } from '@/router/config'
import LayoutDefault from '../layouts/LayoutDefault.vue'

export default {
  name: 'Profile',
  components: {
    InnerDrawer,
    InnerContent,
    ProfileCard,
    LayoutDefault,
  },
  computed: {
    ...mapGetters('dictionariesStates', ['getMimeTypes']),
    getProfileMenu() {
      let profileRoutes

      if (protectedRoute) {
        profileRoutes = protectedRoute.find(el => el.name === 'Profile')

        if (profileRoutes && profileRoutes.children) {
          profileRoutes = profileRoutes.children
        }
      }

      return Array.isArray(profileRoutes) ? profileRoutes : []
    },
    user: {
      get() {
        return this.$store.state.userStates.user
      },
      set(val) {
        this.$store.commit('userStates/updateUser', val)
      },
    },
    ...mapGetters({
      getProfileId: 'userStates/getProfileId',
    }),
  },
  data: () => ({}),
  methods: {
    ...mapActions('userStates', ['updateProfilePicture']),
    async updateAvatar(data) {
      const that = this
      await this.updateProfilePicture({
        profileId: this.getProfileId,
        file: data,
        retry: false,
      })
    },
    convertImageToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
  },
}
</script>
